import { render, staticRenderFns } from "./follow-time.vue?vue&type=template&id=52acb431&scoped=true"
import script from "./follow-time.vue?vue&type=script&lang=js"
export * from "./follow-time.vue?vue&type=script&lang=js"
import style0 from "./follow-time.vue?vue&type=style&index=0&id=52acb431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52acb431",
  null
  
)

export default component.exports